<template>
  <div>
    <v-row align="center" class="pa-4">
      <v-card-title>Журнал открытия с приложения</v-card-title>
      <div class="ml-2">
        <BaseTextField
          v-model="filterApartment"
          :is-button="false"
          :is-switch="true"
          icon="mdi-magnify"
          label="Введите номер квартиры"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer mt-1 mb-2"
            v-bind="attrs"
            v-on="on"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="mobileHeadersJournal"
      :items="filtered"
      :footer-props="{
        'items-per-page-options': [10, 15, 20, 50],
        showFirstLastPage: true
      }"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ ruDateFormat(item.created_at) }}
      </template>
      <template v-slot:item.abonent\.telephone="{ item }">
        <div v-if="item.abonent">
          <router-link class="routerLink" :to="`/client/${item.abonent.clients[0].id}`">
            {{ formatPhoneNumber(item.abonent.telephone) }}
          </router-link>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { mobileHeadersJournal } from '../consts';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../../BaseTextField';
import formatPhoneNumber from '../../../../mixins/formatPhoneNumber';

export default {
  name: 'MobileDoorOpening',
  components: { BaseTextField },
  props: ['id'],
  mixins: [ruDateFormatMixin, formatPhoneNumber],
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 1000,
      },
      filterApartment: '',
      filters: { doorphone_id: this.$route.params.id },
      sort: '',
      pagination: 1,
      mobileHeadersJournal,
      include: ['door,abonent.clients'],
    };
  },
  created () {
    this.loadDoorOpeningMobile();
  },
  computed: {
    ...mapGetters({
      doorOpeningMobiles: 'DoorOpenning/doorOpeningMobiles',
    }),
    filtered () {
      if (this.filterApartment) {
        return this.doorOpeningMobiles.filter(item => {
          return item.abonent &&
            item.abonent.apartment !== null &&
            String(item.abonent.apartment).toLowerCase().includes(this.filterApartment.toLowerCase());
        });
      } else {
        return this.doorOpeningMobiles;
      }
    },
  },
  methods: {
    ...mapActions({
      getDoorOpeningMobile: 'DoorOpenning/getDoorOpeningMobile',
      getDoorOpeningMobiles: 'DoorOpenning/getDoorOpeningMobiles',
    }),
    async updateInfo () {
      await this.loadDoorOpeningMobile()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    async loadDoorOpeningMobile () {
      await this.getDoorOpeningMobiles({
        pagination: this.pagination,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        include: this.include,
        filters: this.filters,
        sort: this.sort,
      })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить журнал открытия с приложения');
        });
    },
  },
};
</script>

<style lang="scss" scoped>

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
